import React from 'react';
import Layout from '@/components/layout/Layout';
import Hero from '@/components/home/Hero';
import HowItWorks from '@/components/home/HowItWorks';
import FeaturedTeachers from '@/components/home/FeaturedTeachers';
import Testimonials from '@/components/home/Testimonials';
import CallToAction from '@/components/home/CallToAction';
import { SEO, createOrganizationSchema, createWebsiteSchema, createLocalBusinessSchema } from '@/components/seo';
import { useLanguage } from '@/contexts/LanguageContext';

const Index = () => {
  const { language } = useLanguage();

  // Combine organization, website, and local-business schemas
  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      createOrganizationSchema(language),
      createWebsiteSchema(language),
      createLocalBusinessSchema({ language })
    ]
  };
  
  return (
    <Layout>
      <SEO
        titleKey="seo.home.title"
        descriptionKey="seo.home.description"
        keywordsKey="seo.home.keywords"
        structuredData={structuredData}
      />
      <Hero />
      <HowItWorks />
      <FeaturedTeachers />
      <Testimonials />
      <CallToAction />
    </Layout>
  );
};

export default Index;
